<template>
    <el-dialog
            :title="$t('SET_IP_WHITE_LIST_TITLE')"
            :visible.sync="ipWhiteListVisible"
            width="40%"
            :close-on-click-modal="false"
            :before-close="closeIpWhiteList"
    >
        <span slot="title">
            <span class="font18">{{ $t('SET_IP_WHITE_LIST_TITLE') }}</span>
            <i class="el-icon-warning info-cls" />
            <span style="font-size: 12px; color: #fd349c;">
                {{$t('IP_WHITE_LIST_TIP')}}
            </span>
        </span>
       <!-----------------新增--------------start----------->
        <div class="right">

            <el-popover
                    placement="left-start"
                    width="350"
                    v-model="addVisible"
                    trigger="manual"
            >
                <el-form :model="addWhiteForm" :rules="rules" ref="addIpWhiteFormRef">
                    <el-form-item prop="ip">
                        <el-input
                                v-model="addWhiteForm.ip"
                                :placeholder="$t('ENTER_IP_WHITE_LIST_PLACEHOLDER')"
                                type="text"
                                clearable
                                style="font-size: 12px"
                                @keyup.enter.native="submitForm('addIpWhiteFormRef')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="btn-cls">
                        <el-button size="mini" class="cancel-btn" @click="closeAdd" style="font-size: 12px">{{ $t('btn_cancel') }}</el-button>
                        <el-button class="wl-green" size="mini" @click="submitForm('addIpWhiteFormRef')" style="font-size: 12px"> {{ $t('btn_confirm') }}</el-button>
                    </el-form-item>
                </el-form>
                <el-button slot="reference" class="wl-green" plain @click="showAdd" style="font-size: 12px" icon="el-icon-plus">{{ $t('COMMON_ADD')}}</el-button>
            </el-popover>
        </div>
        <!-------------------------新增--------------end----------->
        <el-table
                :data="tableData"
                style="width: 100%">
            <el-table-column
                    :label="$t('WHITE_LIST')">
                <template slot-scope="scope">
                    <el-input
                            v-model="scope.row.ip"
                            clearable
                            v-if="showEdit == 'ip'+scope.$index"
                            class="email-input-cls"
                            type="text"
                            @change="editIp(scope.$index,scope.row)"
                            @keyup.enter.native="editIp(scope.$index,scope.row)"
                    ></el-input>
                    <span style="margin-left: 10px" v-else>{{ scope.row.ip }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('TABLE_HEADER_Action')">
                <template slot-scope="scope">
                    <i class="el-icon-edit-outline wl-icon-edit" aria-hidden="true" @click="handleEdit(scope.$index, scope.row)"></i>
                    <el-popconfirm
                            :title="$t('WHITE_LIST_DELE_WARNING') "
                            placement="top"
                            @confirm="handleDelete(scope.$index, scope.row)"
                            confirm-button-type="success"
                            cancel-button-type="success"
                    >
                        <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" slot="reference"></i>
                    </el-popconfirm>

                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
    import API from '@/api'
    import {mapGetters} from "vuex";
    export default {
        name: "ipWhiteList",
        props: {
            ipWhiteListVisible: Boolean
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            })
        },
        data(){
            var validWhite = (rule, value, callback) => {
                // ipString校验
                let validFlag = false
                if(value.indexOf(',') != -1) {
                    let ipList = value.split(',')
                    validFlag = ipList.every(item => /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(item))
                } else {
                    validFlag = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(value)
                }

                if (!validFlag) {
                    return callback(new Error(this.$t('FORM_VALIDATE_IP')))
                } else {
                    callback()
                }
            };
            return {
                addVisible: false,
                showEdit: '',
                addWhiteForm: {
                    ip: ''
                },
                tableData: [],
                whiteList: [],
                operatingFlag: false,
                rules: {
                    ip: [
                        {required: true, message: this.$t('ENTER_IP_WHITE_LIST'), trigger: 'blur'},
                        {validator: validWhite, trigger: ['blur', 'change']}
                    ]
                },
            }
        },
        mounted() {
            this.queryWhiteList()
        },
        methods: {
            // 查询白名单
            async queryWhiteList(){
                const res = await API.clientUser.getSiteConfig({param: this.getSite.siteId})
                if(res.code == '1'){
                    if(res.data.ipaddrWhiteList == '' || res.data.ipaddrWhiteList == null){
                        this.tableData = []
                        return
                    }
                    this.whiteList = res.data.ipaddrWhiteList.split(',')
                    let tempList = []
                    this.whiteList.forEach(item => {
                        let temp = {
                            ip: item
                        }
                        tempList.push(temp)
                    })
                    this.tableData = tempList
                } else {
                    this.$message.error(this.$t(res.code));
                }
            },
            //设置白名单
            async setWhiteList(whiteList){
                const res = await API.clientUser.setIpWhiteList({siteId: this.getSite.siteId,ipaddrWhiteList: whiteList})
                if(res.code == '1'){
                    this.$message.success(this.$t('msg_success'))
                    this.addVisible = false
                    this.queryWhiteList()
                } else {
                    this.$message.error(this.$t(res.code));
                }
            },
            // 关闭白名单窗口
            closeIpWhiteList(){
                this.$parent.ipWhiteListVisible = false
            },
            // 显示新增白名单气泡
            showAdd(){
                if(this.operatingFlag){
                    this.$message.error(this.$t('OPERATE_ING_WARNING'))
                } else {
                    this.addVisible = true
                    this.operatingFlag = true
                    this.$refs['addIpWhiteFormRef'].resetFields();
                }
            },
            closeAdd(){
                this.addVisible = false
                this.operatingFlag = false
            },
            // 新增白名单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if(this.whiteList.indexOf(this.addWhiteForm.ip) != -1) {
                        this.$message.error(this.$t('IP_IS_EXIST'))
                        return false;
                    } else if(valid){
                        let whiteStr = this.addWhiteForm.ip
                        this.tableData.forEach(item => {
                            whiteStr += ',' + item.ip
                        })
                        this.setWhiteList(whiteStr)
                        this.whiteList.unshift(this.addWhiteForm.ip)
                        this.operatingFlag = false
                    } else {
                        this.$message.error(this.$t('msg_error'));
                        return false;
                    }
                });
            },
            // 修改白名单--邮箱可修改
            handleEdit(index, row) {
                if(this.operatingFlag){
                    this.$message.error(this.$t('OPERATE_ING_WARNING'))
                }else {
                    this.showEdit = 'ip' + index
                    this.operatingFlag = true
                }
            },
            // 修改白名单
            editIp(index, row){
                let ind = this.whiteList.indexOf(row.ip)
                let [...copyList] = this.whiteList
                copyList.splice(index,1)
                if(row.ip == null || row.ip == ''){
                    this.$message({
                        showClose: true,
                        message: this.$t('ENTER_WHITE_LIST'),
                        type: 'error'
                    });
                    return
                } else if (!/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(row.ip)) {
                    this.$message({
                        showClose: true,
                        message: this.$t('FORM_VALIDATE_IP'),
                        type: 'error'
                    });
                    return
                }else if(copyList.indexOf(row.ip) != -1){
                    this.$message({
                        showClose: true,
                        message: this.$t('IP_IS_EXIST'),
                        type: 'error'
                    });
                    return
                } else {
                    this.showEdit = ''
                    this.whiteList[index] = row.ip
                    this.setWhiteList(this.whiteList.join(','))
                    this.operatingFlag = false
                }
            },
            // 删除白名单
            handleDelete(index, row) {
                if(this.operatingFlag){
                    this.$message.error(this.$t('OPERATE_ING_WARNING'))
                } else {
                    this.whiteList.splice(index,1)
                    this.setWhiteList(this.whiteList.join(','))
                }
            }
        }
    }
</script>

<style scoped>
.font18{
    font-size: 18px;
}
.right{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: -15px 0 5px 0;
    align-items: center;
}
.btn-cls{
    text-align: right;
    margin: 10px 0 0;
}
.edit-cls{
    margin-right: 10px;
    font-size: 12PX;
}
.del-cls{
    font-size: 12PX;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin: 15px 0 0;
}
.email-input-cls{
    width: 180px;
    margin-left: 10px;
}
.info-cls{
    color:#fd349c;
    margin-left: 5px;
}
</style>